import { BooleanDimension } from './boolean-dimension.ts'
import { rcdaSelectedDimension } from './product-selection-dimensions.ts'

type DocumentsValidatedState = { documentsValidated?: boolean }

export const isApplicationValidatedDimension = new BooleanDimension({
  name: 'isApplicationValidated',
  displayKeys: { name: 'dimension_name_is_application_validated' },
  initStrategy: {
    oldNames: ['documentsValidated'],
    computeValue: (state: DocumentsValidatedState) => state.documentsValidated,
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
})

export const mrpaApplicationValidationRequiredDimension = new BooleanDimension({
  name: 'mrpaApplicationValidationRequired',
  displayKeys: { name: 'dimension_name_mrpa_application_validation_required' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
})

export const documentsLockConfirmedDimension = new BooleanDimension({
  name: 'documentsLockConfirmed',
  displayKeys: { name: 'dimension_name_documents_lock_confirmed' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: {
    lockedInQuoteFor: {
      partner: { and: [isApplicationValidatedDimension, rcdaSelectedDimension] },
      platform: { and: [isApplicationValidatedDimension, rcdaSelectedDimension] },
    },
  },
})
